import React from 'react';
import { OrgChartConnectionProps } from './OrgChartConnectionProps';

export const OrgChartConnection = ({ nodeCount }: OrgChartConnectionProps) => {
	return (
		<>
			{nodeCount === 2 && (
				<>
					<div style={{ position: 'absolute', top: '100%', left: '50%', width: '1px', height: '5%', background: '#ccc', transform: 'translateX(-50%)' }} />
					<div style={{ position: 'absolute', top: '105%', left: '0%', width: '50%', height: '1px', background: '#ccc', transform: 'translateX(50%)' }} />
					<div style={{ position: 'absolute', top: '105%', left: '25%', width: '1px', height: '5%', background: '#ccc' }} />
					<div style={{ position: 'absolute', top: '105%', left: '75%', width: '1px', height: '5%', background: '#ccc' }} />
				</>
			)}
			{nodeCount === 1 && (
				<>
					<div style={{ position: 'absolute', top: '100%', left: '50%', width: '1px', height: '10%', background: '#ccc', transform: 'translateX(-50%)' }} />
				</>
			)}
		</>
	);
}
